import { createContext } from 'react';
let globalElement = null;
export const defaultContextValue = {
    boundaryElement: null,
    get element() {
        if (globalElement)
            return globalElement;
        globalElement = document.createElement('div');
        globalElement.setAttribute('data-portal', '');
        document.body.appendChild(globalElement);
        return globalElement;
    },
};
export const PortalContext = createContext(defaultContextValue);
//# sourceMappingURL=context.js.map